/**
 * Created by root on 4/9/19.
 */
 import React from "react";
 import WbHttpClient from "../../services/wbhttpclient";
 
 import { hot } from "react-hot-loader/root";
 
 import { Modal, ModalWrapper, ModalHeader, ModalContent } from '@workboard/wobo-ui';
 import styled from 'styled-components'
 const StyledModal = styled(Modal)`
  ${ModalWrapper} {
    min-height: 175px;
    max-height: 650px;
    height: auto;
    width: 375px;
    padding-bottom: 27px;
  }
  ${ModalHeader} { 
    padding: 10px 20px !important;
  }
  ${ModalContent} {
    padding-top: 0px !important;
    * {
      font-size: 12px;
    }
  }
  ${ModalContent} + div {
    padding: 10px 24px !important;
    button {
      font-size: 14px !important;
    }
  }
 `;
 
class ExternalPublish extends React.Component {
  constructor(props) {
    super(props);
    //console.log("ExtePublish %o", this.props);

    // Make deep copy so its not by reference.
    const initialData = JSON.parse(JSON.stringify(this.props));
    this.initialData = initialData;

    this.state = {
      initialData,
      data: this.props.data,
      channelIds: [],
      channels: [],
      publishUrl: this.props.data.action,
      errors: "",
      teamName: this.props.data.teamName,
      isModalOpen: true
    };
    this.filterExtData = this.filterExtData.bind(this);
    this.publishReportInSlack = this.publishReportInSlack.bind(this);
    this.clearCheckBoxes = this.clearCheckBoxes.bind(this);
    this.keepChecked = this.keepChecked.bind(this);
    this.selectedChannels = this.selectedChannels.bind(this);

    this.WbHttpClient = new WbHttpClient();
  }

  clearCheckBoxes() {
    let checkboxes = document.querySelectorAll("input[name^='slack_ids[']");
    if (checkboxes) {
      for (let check of checkboxes) {
        check.checked = false;
      }
    }
  }

  // Make this filter the data, not to go get more data

  filterExtData(event) {
    let term = event.target.value;
    let _self = this;
    // Reset the filter to the initial data received from the API request.
    Object.assign(_self.state.data, _self.state.initialData.data)
    clearTimeout(_self.requestTimer);

    _self.requestTimer = setTimeout(() => {
      new Promise ((resolve) => {
        let filteredData = _self.state;
        let channels = Object.values(filteredData.data.channels);
        filteredData.data.channels = channels.filter((i) => {
          return (i.name.includes(term));
        })
        _self.setState({ ...filteredData });
        resolve(filteredData);
      })
      .then(function(response) {
        _self.clearCheckBoxes();
        setTimeout(() => _self.keepChecked(), 10);
      });
    }, 500);
  }

  keepChecked() {
    let checkboxes = document.querySelectorAll("input[name^='slack_ids[']");
    if (checkboxes) {
      let selectedChannels = this.state.channels;
      console.log("-");
      for (let check of checkboxes) {
        let v = check.value;
        let found = _.find(Object.values(selectedChannels), ch => ch.id == v);
        if (found) {
          console.log("checked " + check.value);
          check.checked = true;
        }
      }
    }
  }

  selectedChannels(event) {
    let id = event.target.value;
    let allChannels = this.state.data.channels;
    let channels = this.state.channels;
    if (event.target.checked) {
      let channel = _.find(allChannels, ch => ch.id == id);
      channels[id] = channel;
      this.setState({ channels: channels });
      this.setState({ errors: "" });
    } else {
      channels = _.reject(channels, ch => ch.id == id);
      this.setState({ channels: channels });
    }
  }

  /**
  * Publishing the report in slack
  * @param callBack
  */
  publishReportInSlack() {
    let params = { appId: 1 };
    let checkedSlackBoxes = document.querySelectorAll(
      "input[name^='slack_ids[']:checked"
    );
    let slackIds = [];
    if (checkedSlackBoxes) {
      for (let check of checkedSlackBoxes) {
        if (check.value) {
          slackIds.push(check.value);
        }
      }
    }
    if (!slackIds.length) {
      this.setState({ errors: "Please select at least one channel." });
    } else {
      params["slack_ids"] = slackIds;
      this.WbHttpClient.post(this.state.publishUrl, params).then(function(
        response
      ) {
        if (response.data) {
          closePublishingReportsInExternalSystem();
          infoPopup.call(" &nbsp;&nbsp;&nbsp;Successfully published in Slack.");
        }
      });
    }
  }

  handleModal = (close) => {
    this.setState({isModalOpen: close})
  }

  render() {
    return (
      <StyledModal
        disableScrollLock
        id="slack-publish-container"
        isOpen={this.state.isModalOpen}
        onDismiss={() => this.handleModal(false)}
        onSubmit={(e) => {
          this.publishReportInSlack(e)
          this.handleModal(false)
        }}
        style={{backgroundColor: "rgba(170,170,170, 0.3) !important"}}
        submitLabel="Publish"
        title={
          <div className="slack-team-title">
            Slack team:{" "}
            <span id="slack-team-name" style={{ fontWeight: 600 }}>
              {this.state.teamName}
            </span>
          </div>
        }
      >
        <div className="publisher-slack-publish-popup">
          <div className="goal-table-row">
            <div className="goal-table-col" style={{ width: "435px" }}>
              <input
                type="text"
                id="slack-channel-input"
                placeholder="Search Slack channels"
                className="search-input-text"
                onChange={event => this.filterExtData(event)}
                aria-label="Search Slack channels"
              />
            </div>
          </div>
          <div className="email-error-msg" role="alert">{this.state.errors}</div>
          <div
            id="slack-list"
            className="goal-table-tmp verticalScroll fixed-height"
            style={{ maxHeight: "275px", overflow: "auto" }}
          >
            {this.state.data.channels &&
              Object.values(this.state.data.channels).map(c => (
                <div className="goal-table-row divInlineBlock metricUpdate">
                  <div
                    className="goal-table-col extPublishCheck selection-option-check"
                    style={{ width: "40px" }}
                  >
                    <input
                      id={"slack_" + c.id}
                      className="wsSearchCheckbox slack-ids-ims screen-reader-only"
                      data-slack-id={c.id}
                      type="checkbox"
                      name="slack_ids[]"
                      value={c.id}
                      onChange={e => this.selectedChannels(e)}
                      aria-labelledby={`slack-publish-modal-label-${c.id}`}
                    />
                    <label
                      htmlFor={"slack_" + c.id}
                    ></label>
                  </div>
                  <div id={`slack-publish-modal-label-${c.id}`} className="goal-table-col">{c.name}</div>
                </div>
              ))}
          </div>
        </div>
      </StyledModal>
    );
  }
}
export default hot(ExternalPublish);
